import httpClient from "constants/httpClient";
import { BASE_URL, DASHBOARD } from "constants/appConstant";

const getDesigns = async (limit, page) => {
  return await httpClient.get(
    `${DASHBOARD.GET_DESINGS}?limit=${limit}&page=${page}`
  );
};

const createFolder = async (values) => {
  return await httpClient.post(DASHBOARD.CREATE_FOLDER, values);
};

const getFolders = async () => {
  return await httpClient.get(DASHBOARD.GET_FOLDERS);
};

const getFoldersData = async (selectedFolder, limit, page) => {
  return await httpClient.get(
    `${DASHBOARD.GET_FOLDERS_DATA}/${selectedFolder}?limit=${limit}&page=${page}`
  );
};

const getTrashedDesgins = async (limit, page) => {
  return await httpClient.get(
    `${DASHBOARD.GET_TRASHED_DESIGNS}?limit=${limit}&page=${page}`
  );
};

const getTrashedFolders = async () => {
  return await httpClient.get(`${DASHBOARD.GET_TRASHED_FOLDERS}`);
};

const getTrashedFolderDesigns = async (folderId,limit,page) => {
  return await httpClient.get(`${DASHBOARD.GET_TRASHED_FOLDER_DESIGNS}/${folderId}?limit=${limit}&page=${page}`);
};

const deleteFolder = async (openFolder) => {
  return await httpClient.delete(
    `${DASHBOARD.DELETE_TRASHED_FOLDER}/${openFolder}`
  );
};

const trashFolder = async (openFolder) => {
  return await httpClient.delete(`${DASHBOARD.TRASH_FOLDER}/${openFolder}`);
};

const deleteDesign = async (ids) => {
  return await httpClient.post(DASHBOARD.DELETE_TRASHED_DESIGNS, {
    designIds: ids,
  });
};

const trashDesigns = async (ids) => {
  return await httpClient.post(DASHBOARD.TRASH_DESIGN, { designIds: ids });
};

const clearTrash = async () => {
  return await httpClient.delete(DASHBOARD.CLEAR_TRASH);
};

const restoreTrashedItem = async (values) => {
  return await httpClient.post(DASHBOARD.RESTORE_TRASHED_ITEM, values);
};

const requestDesigns = async (values) => {
  return await httpClient.post(DASHBOARD.REQUEST_DESIGN, values);
};

const moveFilesToFolder = async (values) => {
  return await httpClient.patch(DASHBOARD.MOVE_TO_FOLDER, values);
};

const renameFolder = async (values) => {
  return await httpClient.patch(DASHBOARD.RENAME_FOLDER, values);
};

const filterDesigns = async (values) => {
  return await httpClient.post(DASHBOARD.FILTER_DESIGN, values);
};

const downloadFolderDesigns = async (folderId) => {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const response = await fetch(
    `${BASE_URL}${DASHBOARD.DOWNLOAD_FOLDER_DESIGNS}?folderId=${folderId}`,
    {
      method: "GET",
      headers: {
        Accept: "application/octet-stream",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response;
};

const downloadDesign = async (url, name) => {
  const { token } = JSON.parse(localStorage.getItem("user"));

  const response = await fetch(
    `${BASE_URL}${DASHBOARD.DOWNLOAD_DESIGN}?design=${url}&name=${name}`,
    {
      method: "GET",
      headers: {
        Accept: "application/octet-stream",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response;
};

const downloadFile = (url, name) => {
  const link = document.createElement('a');
  link.href = url;
  const filename = `${name}.png`
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export {
  getTrashedFolderDesigns,
  restoreTrashedItem,
  getTrashedFolders,
  getTrashedDesgins,
  filterDesigns,
  getDesigns,
  createFolder,
  getFolders,
  getFoldersData,
  moveFilesToFolder,
  deleteFolder,
  deleteDesign,
  trashDesigns,
  trashFolder,
  clearTrash,
  requestDesigns,
  renameFolder,
  downloadFolderDesigns,
  downloadDesign,
  downloadFile
};
